import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { LogOut } from 'lucide-react';
import { theme } from '@styles/theme';
import { Button } from '@components/Button';
const Container = styled.div `
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.background.primary};
`;
const Header = styled.header `
  height: 64px;
  padding: 0 ${theme.spacing.lg};
  border-bottom: 1px solid ${theme.colors.border.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.background.secondary};
`;
const Logo = styled.div `
  display: flex;
  align-items: baseline;
  gap: ${theme.spacing.sm};
`;
const LogoText = styled.h1 `
  font-size: ${theme.typography.fontSize.xl};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.primary};
  letter-spacing: -0.02em;
`;
const LogoTagline = styled.span `
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.colors.text.muted};
`;
const HeaderActions = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;
const UserInfo = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;
const UserAvatar = styled.div `
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${theme.colors.background.tertiary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
`;
const UserName = styled.span `
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  color: ${theme.colors.text.secondary};
`;
const Main = styled.main `
  flex: 1;
  padding: ${theme.spacing.lg};
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;
const PageTitle = styled.h1 `
  font-size: ${theme.typography.fontSize['2xl']};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.lg};
`;
const PageDescription = styled.p `
  font-size: ${theme.typography.fontSize.base};
  color: ${theme.colors.text.secondary};
  margin-bottom: ${theme.spacing.xl};
`;
function getInitials(name) {
    return name
        .split(' ')
        .map((part) => part[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
}
export function ClientLayout({ onLogout, userName = 'User' }) {
    return (_jsxs(Container, { children: [_jsxs(Header, { children: [_jsxs(Logo, { children: [_jsx(LogoText, { children: "Shift" }), _jsx(LogoTagline, { children: "Prototypes" })] }), _jsxs(HeaderActions, { children: [_jsxs(UserInfo, { children: [_jsx(UserAvatar, { children: getInitials(userName) }), _jsx(UserName, { children: userName })] }), _jsxs(Button, { variant: "ghost", size: "sm", onClick: onLogout, children: [_jsx(LogOut, { size: 18 }), "Sign Out"] })] })] }), _jsxs(Main, { children: [_jsx(PageTitle, { children: "Your Prototypes" }), _jsx(PageDescription, { children: "Access the prototypes that have been shared with you. Click on any prototype to launch it." }), _jsx(Outlet, {})] })] }));
}
